import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { base44 } from '@/api/base44Client';
import RigCard from '@/components/showcase/RigCard';

export default function ShowcaseRelatedRigs({ rig }) {
  const { data: rigs = [], isLoading } = useQuery({
    queryKey: ['showcase-related', rig.category],
    queryFn: () => base44.entities.ShowcaseRig.filter({ category: rig.category }, 'sort_order', 20),
  });

  const related = rigs.filter((r) => r.id !== rig.id).slice(0, 3);
  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <Loader2 className="w-5 h-5 animate-spin text-primary" />
      </div>
    );
  }
  if (related.length === 0) return null;

  return (
    <section className="py-20 px-6 lg:px-10 border-t border-white/5 bg-[#111115]">
      <div className="max-w-7xl mx-auto">
        <p className="text-primary text-xs font-bold tracking-widest mb-3">KEEP EXPLORING</p>
        <h2 className="text-white font-black text-3xl md:text-4xl uppercase mb-10">Related Rigs</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {related.map((r, i) => (
            <RigCard key={r.id} rig={r} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}